import {ApprovalGroups} from "js/jsx/src/classes/admin/approvals/ApprovalGroups.jsx"

export default function approvalgroups(){
    var loadApprovalGroupsPage = function () {
        quosal.ui.react.render(<DialogManager/>, document.getElementById('dialogManager'));
        quosal.ui.react.render(<ApprovalGroups />, document.getElementById('currentDocument'));
        $('#pageName').val('approvalgroups.quosalweb');
    };
    quosal.sell.modules.onAfterLoad.unbind().bind(loadApprovalGroupsPage);
}